import { Customer, Task, TaskAggregations, TaskAutoDispatchStatus, WayPoint } from '@bringg/types';
import { getSharedRootStore, hasFeatureFlag } from '@bringg-frontend/global-stores';

export const BATCH_GET_FIELDS_FEATURE_FLAG = 'enable_batch_get_fields_react';

/** Column list for tasks batch_get and the tasks store loaders, checked against the entity types. */
export type TaskFields = (
	| keyof Task
	| { way_points: (keyof WayPoint | { customer: (keyof Customer)[] })[] }
	| { aggregations: (keyof TaskAggregations)[] }
	| { task_auto_dispatch_status: (keyof TaskAutoDispatchStatus)[] }
)[];

/**
 * Fields for a tasksStore.loadMany call that reads only a few task columns.
 * Returns undefined while the flag is off, which keeps the full-task request.
 */
export function batchGetFields(
	fields: TaskFields,
	featureFlag = BATCH_GET_FIELDS_FEATURE_FLAG
): TaskFields | undefined {
	const { currentUser } = getSharedRootStore().data.usersStore;

	return hasFeatureFlag(currentUser, featureFlag) ? fields : undefined;
}
